import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { useGtmEvent } from "./useGtmEvent";

const SESSION_KEY = "session_start";

const getStart = () => Number(sessionStorage.getItem(SESSION_KEY));
const setStart = () => sessionStorage.setItem(SESSION_KEY, Date.now().toString());
const clearStart = () => sessionStorage.removeItem(SESSION_KEY);

export const useSessionTime = () => {
  const { pushEvent } = useGtmEvent();

  useEffect(() => {
    if (!getStart()) setStart();

    const sendSessionEnd = () => {
      const start = getStart();
      if (!start) return;
      pushEvent("session_end", {
        duration_seconds: Math.round((Date.now() - start) / 1000),
      });
    };

    if (Capacitor.isNativePlatform()) {
      let listenerHandle: { remove: () => Promise<void> } | null = null;

      App.addListener("appStateChange", ({ isActive }) => {
        if (!isActive) {
          sendSessionEnd();
          clearStart();
        } else {
          setStart();
        }
      }).then((handle) => {
        listenerHandle = handle;
      });

      return () => {
        listenerHandle?.remove();
      };
    } else {
      const handleVisibilityChange = () => {
        if (document.visibilityState !== "hidden") return;
        sendSessionEnd();
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    }
  }, []);
};
